import {DeviceType, Dto} from 'common';

export class DeviceSessions extends Dto {
    device: DeviceType;
    sessionsInThreeMonths: number;
    totalSessions: number;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
